// strToNumber.js
// '10,000' 과 같은 문자열을 10000 같은 정수로 변환해서 리턴
// parseInt() 보다 Number() 의 성능이 더 빠르므로 Number()를 사용한다.
// [2021.3.16] val 이 정수면 고대로 리턴하도록 수정
export default (val = '') => {
  if (!val) return ''
  return (typeof val === 'number') ? val : Number(val.replace(/,/g, ''))
}
